import { useEffect, useLayoutEffect } from 'react';

/**
 * При SSR любых компонентов, в которых есть useLayoutEffect, вылетает предупреждение о том
 *   что useLayoutEffect не исполняется на сервере. Фактически это и есть ожидаемое поведение
 * https://react.dev/reference/react/useLayoutEffect#im-getting-an-error-uselayouteffect-does-nothing-on-the-server
 *
 * Для исправления на SSR заменяем хук на useEffect
 */
export var useIsomorphicLayoutEffect = function useIsomorphicLayoutEffect(callback, deps) {
  var useIsomorphicHook = typeof window === 'undefined' ? useEffect : useLayoutEffect;
  return useIsomorphicHook(callback, deps);
};